import { Inbox, Send, CheckCircle2, XCircle, Clock, CircleSlash, FileEdit } from 'lucide-react';

const FILTERS = [
  { key: 'all', label: 'All', Icon: Inbox },
  { key: 'awaiting_others', label: 'Awaiting others', Icon: Send },
  { key: 'completed', label: 'Completed', Icon: CheckCircle2 },
  { key: 'declined', label: 'Declined', Icon: XCircle },
  { key: 'expired', label: 'Expired', Icon: Clock },
  { key: 'voided', label: 'Voided', Icon: CircleSlash },
  { key: 'draft', label: 'Drafts', Icon: FileEdit },
];

export default function StatusFilterRail({ active, counts, onChange }) {
  return (
    <nav className="w-full lg:w-52 shrink-0 space-y-0.5">
      {FILTERS.map(({ key, label, Icon }) => {
        const count = counts ? counts[key] ?? 0 : null;
        const isActive = active === key || (!active && key === 'all');
        return (
          <button
            key={key}
            onClick={() => onChange(key === 'all' ? null : key)}
            className={`w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg text-sm transition text-left ${
              isActive
                ? 'bg-indigo-50 text-indigo-700 font-medium'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <span className="flex items-center gap-2 min-w-0">
              <Icon className="w-4 h-4 shrink-0" />
              <span className="truncate">{label}</span>
            </span>
            {count !== null && (
              <span
                className={`text-xs px-1.5 py-0.5 rounded-full min-w-[1.5rem] text-center ${
                  isActive ? 'bg-white text-indigo-700' : 'bg-gray-100 text-gray-500'
                }`}
              >
                {count}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
